module.exports = __webpack_public_path__ + "static/robotsim3-ac17b3cca9a679aa35ef9419d8f09281.jpg";